import { useReducer } from "react";
import api from "../../api/requests";

const intialState = {
  municipals: [],
  regions: [],
  specialities: [],
  worldSkills: [],
  roles: []
};

function reducer(state, action) {
  switch (action.type) {
    case "MO_LIST":
      return {
        ...state,
        municipals: action.municipals
      };
    case "REGION_LIST":
      return {
        ...state,
        regions: action.regions
      };
    case "SPEC_LIST":
      return {
        ...state,
        specialities: action.specialities
      };
    case "WS_LIST":
      return {
        ...state,
        worldSkills: action.worldSkills
      };
    case "ROLE_LIST":
      return {
        ...state,
        roles: action.roles
      };
    default:
      return {
        ...state
      };
  }
}

export default function useRequestInfo() {
  const [dataSources, dispatch] = useReducer(reducer, intialState);

  function getRegionList() {
    api.getRegionList().then(({ data }) => {
      dispatch({ type: "REGION_LIST", regions: data });
    });
  }

  function getMunicipalList(id) {
    api.getMunicipalsList(id).then(({ data }) => {
      dispatch({ type: "MO_LIST", municipals: data });
    });
  }

  function getSpecialitiesList() {
    api.getSpecialitiesList().then(({ data }) => {
      dispatch({ type: "SPEC_LIST", specialities: data });
    });
  }

  function getWorldSkillsList() {
    api.getWorldSkillsList().then(({ data }) => {
      dispatch({ type: "WS_LIST", worldSkills: data });
    });
  }

  function getRolesList() {
    api.getRolesList().then(({ data }) => {
      dispatch({ type: "ROLE_LIST", roles: data });
    });
  }

  return {
    dataSources,
    getRegionList,
    getMunicipalList,
    getSpecialitiesList,
    getWorldSkillsList,
    getRolesList
  };
}
